import { render, staticRenderFns } from "./BaseFormM.vue?vue&type=template&id=05e751fc&scoped=true"
import script from "./BaseFormM.vue?vue&type=script&lang=js"
export * from "./BaseFormM.vue?vue&type=script&lang=js"
import style0 from "./BaseFormM.vue?vue&type=style&index=0&id=05e751fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e751fc",
  null
  
)

export default component.exports